import { errorResponse, deleteResponse, errorAnyCodeResponse, successResponse } from './utils/response-templates.js';
export const commonErrorCodeResponseSchema = errorAnyCodeResponse('An error occurred');
export const notFoundResponseSchema = errorResponse('Not found');
export const permissionDeniedResponseSchema = errorResponse('Permission denied');
export const unauthorizedResponseSchema = errorResponse('Unauthorized');
export const unprocessableEntityResponseSchema = errorAnyCodeResponse('Unprocessable entity');
export const badRequestResponseSchema = errorAnyCodeResponse('Bad request');
export const successResponseSchema = successResponse();
export const deleteResponseSchema = deleteResponse();
